module.exports = __webpack_public_path__ + "img/Group_27947.285803b0.svg";